import { configureStore } from './helpers';
import {
  SEARCH_RESULTS_FEATURE_KEY,
  searchResultsReducer,
} from './searchResults.slice';

import {
  SEARCH_VALUE_FEATURE_KEY,
  searchValueReducer,
} from './searchValue.slice';

export const reduxStore = configureStore({
  reducer: {
    // From One Admin
    // [APPCONTEXT_FEATURE_KEY]: appContextReducer,
    // [AUTH_FEATURE_KEY]: authReducer,
    // [REGIONAL_FEATURE_KEY]: regionalReducer,
    // [SEARCH_FEATURE_KEY]: searchReducer,
    // [USER_FEATURE_KEY]: userReducer,
    // [ACCOUNT_FEATURE_KEY]: accountReducer,
    // OSC
    [SEARCH_RESULTS_FEATURE_KEY]: searchResultsReducer,
    [SEARCH_VALUE_FEATURE_KEY]: searchValueReducer,
  },
  devTools: true,
});
